import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystaonrentinpune() {



  const cardData = {
"keyword": "Innova Crysta On rent in pune",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Innova Crysta On rent in pune for premium outstation travel, family trips, corporate journeys, airport transfers, pilgrimage tours, and weekend getaways. Whether you are planning a long-distance trip or a comfortable group travel experience, our Innova Crysta service ensures a smooth, safe, and luxurious ride. With spacious 7-seater comfort, powerful AC, extra legroom, ample luggage space, and experienced professional drivers, we provide a stress-free travel experience from Pune. Our vehicles are well-maintained for highway performance and long-route comfort, making them ideal for both short and extended journeys. With transparent pricing and no hidden charges, flexible one-way and round-trip options, doorstep pickup from Pune, easy booking, and 24/7 customer support, Shivai Travels ensures a premium and reliable travel experience with Innova Crysta rentals.",

"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are the most popular hill stations near Pune, known for scenic viewpoints, waterfalls, caves, and pleasant weather, making them ideal for Innova Crysta family trips and weekend getaways."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a famous hill station known for strawberries, lush green valleys, viewpoints, and cool climate, making it a top destination for luxury group travel from Pune."
  },
  {
    "title": "Goa",
    "description":
      "Goa is a top long-distance destination from Pune, famous for beaches, nightlife, water sports, and coastal drives, often chosen for comfortable Innova Crysta road trips."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba, frequently visited by families and groups using Innova Crysta for a comfortable darshan journey."
  },
  {
    "title": "Nashik & Trimbakeshwar",
    "description":
      "Nashik is known for religious tourism, vineyards, and Trimbakeshwar Jyotirlinga, making it a popular spiritual and leisure travel destination from Pune."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal beach destination near Mumbai known for clean beaches, forts, and resorts, ideal for relaxing group trips in luxury vehicles."
  },
  {
    "title": "Konkan Beaches (Kashid, Murud, Diveagar)",
    "description":
      "Konkan beaches like Kashid, Murud Janjira, and Diveagar are popular weekend destinations from Pune for beach relaxation and scenic coastal drives."
  },
  {
    "title": "Ajanta & Ellora Caves",
    "description":
      "Ajanta and Ellora Caves near Aurangabad are UNESCO World Heritage Sites, often visited by families and tourists using Innova Crysta for comfortable heritage tours."
  },
  {
    "title": "Pune City Sightseeing",
    "description":
      "Innova Crysta rentals are also used for Pune city tours covering Shaniwar Wada, Aga Khan Palace, Dagdusheth Temple, and other major attractions."
  },
  {
    "title": "Western Ghats Scenic Route",
    "description":
      "The Pune highway routes for Innova Crysta travel pass through the Western Ghats, offering green valleys, ghats, tunnels, and scenic landscapes for a comfortable journey."
  }
],



services: [
  {
    name: "Innova Crysta Rental Pune",
    description: "Innova Crysta rental Pune service provides premium transportation for family trips, corporate tours, airport transfers, weddings, and outstation journeys. Comfortable Innova Crysta vehicles with experienced drivers ensure smooth and safe travel for local and long-distance routes. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles offer spacious seating, luxury interiors, air conditioning, and luggage space suitable for premium travel requirements. Flexible booking options allow convenient Innova Crysta rental reservations in Pune."
  },
  {
    name: "Pune Innova Crysta Cab",
    description: "Pune Innova Crysta cab service offers dependable transportation solutions for travelers within Pune and nearby destinations. Vehicles provide spacious seating and comfortable highway travel suitable for tourism, corporate outings, pilgrimage tours, and family vacations. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient Innova Crysta cab reservations."
  },
  {
    name: "Innova Crysta on Hire Pune",
    description: "Innova Crysta on hire Pune service provides affordable and comfortable premium travel options for local and outstation journeys. Travelers can enjoy smooth trips with experienced drivers familiar with city roads, highways, and tourist destinations. Vehicles ensure spacious seating and safe transportation suitable for weddings, family vacations, and corporate travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Innova Crysta hire reservations."
  },
  {
    name: "Innova Crysta Taxi Pune",
    description: "Innova Crysta taxi Pune service provides high-quality transportation for passengers seeking comfortable and stylish travel. Vehicles offer spacious seating, premium interiors, luggage capacity, and smooth ride quality suitable for tourism, wedding events, and executive travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova Crysta taxi reservations."
  },
  {
    name: "Pune Innova Crysta Booking",
    description: "Pune Innova Crysta booking service offers economical and comfortable luxury transportation for small and large groups traveling within Pune and nearby destinations. Vehicles provide smooth highway travel with spacious seating suitable for one-day tours, outstation journeys, and group outings. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova Crysta booking reservations."
  },
  {
    name: "Cheap Innova Crysta Pune",
    description: "Cheap Innova Crysta Pune service provides comfortable transportation for families, corporate teams, and tourists traveling within Pune and outstation destinations. Vehicles ensure smooth highway travel with spacious seating and luggage capacity suitable for tourism, pilgrimage tours, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient budget-friendly Innova Crysta reservations."
  },
  {
    name: "Outstation Innova Crysta Pune",
    description: "Outstation Innova Crysta Pune service offers spacious transportation for travelers planning family tours, corporate outings, sightseeing trips, and long-distance journeys. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for extended travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation Innova Crysta reservations."
  },
  {
    name: "Innova Crysta for Family Trip Pune",
    description: "Innova Crysta for family trip Pune service provides reliable transportation for families traveling for vacations, sightseeing, pilgrimage trips, and weekend getaways. Vehicles offer spacious seating, luggage space, and comfortable travel suitable for local and outstation journeys. Professional drivers ensure smooth travel and dependable pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient family Innova Crysta reservations."
  },
  {
    name: "Pune Airport Innova Crysta Cab",
    description: "Pune airport Innova Crysta cab service provides dependable transportation for airport pickup and drop services from Pune Airport and nearby locations. Comfortable vehicles ensure smooth highway travel suitable for corporate travelers, families, and tourists. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available across Pune including homes, hotels, railway stations, and airports. Flexible booking options allow convenient airport Innova Crysta reservations."
  },
  {
    name: "Innova Crysta Wedding Rental Pune",
    description: "Innova Crysta wedding rental Pune service offers spacious and comfortable transportation for wedding guests, family functions, receptions, and destination wedding travel. Vehicles provide comfortable seating and luggage space suitable for safe and enjoyable wedding journeys. Professional drivers ensure punctual pickup and dependable transportation services throughout the trip. Pickup services are available from homes, hotels, railway stations, banquet halls, and airports across Pune. Flexible booking options allow convenient wedding Innova Crysta reservations."
  },
  {
    name: "Innova Crysta One Way Pune",
    description: "Innova Crysta one way Pune service provides premium transportation for one-side journeys from Pune to outstation destinations. Vehicles ensure comfortable seating and smooth travel suitable for airport drops, business trips, tourism, and family travel. Professional chauffeurs ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient one-way Innova Crysta reservations."
  },
  {
    name: "Innova Crysta Round Trip Pune",
    description: "Innova Crysta round trip Pune service offers reliable group transportation for sightseeing tours, family vacations, pilgrimage journeys, and business travel with return options. Vehicles provide spacious seating and luggage space suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient round trip Innova Crysta reservations."
  },
  {
    name: "Best Innova Crysta Service Pune",
    description: "Best Innova Crysta service Pune provides complete luxury transportation solutions for local and outstation travel requirements. Vehicles ensure smooth highway travel suitable for tourism, corporate events, pilgrimage tours, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient premium Innova Crysta service reservations."
  },
  {
    name: "SUV Innova Crysta Hire Pune",
    description: "SUV Innova Crysta hire Pune service offers comfortable and dependable transportation with modern vehicles and experienced chauffeurs. Vehicles are suitable for weddings, family trips, airport transfers, sightseeing tours, and outstation travel. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV Innova Crysta hire reservations."
  },
  {
    name: "Premium Innova Crysta Pune",
    description: "Premium Innova Crysta Pune service provides luxury transportation for travelers looking for premium travel experiences with spacious seating and comfortable interiors. Vehicles are suitable for corporate events, destination weddings, sightseeing trips, and family tours. Professional chauffeurs ensure smooth journeys and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient premium Innova Crysta reservations."
  }
],

tableData: [
  ["Innova Crysta Rental Pune", "Pune Innova Crysta Cab"],
  ["Innova Crysta on Hire Pune", "Innova Crysta Taxi Pune"],
  ["Pune Innova Crysta Booking", "Cheap Innova Crysta Pune"],
  ["Outstation Innova Crysta Pune", "Innova Crysta for Family Trip Pune"],
  ["Pune Airport Innova Crysta Cab", "Innova Crysta Wedding Rental Pune"],
  ["Innova Crysta One Way Pune", "Innova Crysta Round Trip Pune"],
  ["Best Innova Crysta Service Pune", "SUV Innova Crysta Hire Pune"],
  ["Premium Innova Crysta Pune", "Innova Crysta Rental Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Innova Crysta on Rent in Pune",
        WhyChoosedescription: "Shivai Travels provides reliable Innova Crysta rental service in Pune with professional drivers, luxury seating, and punctual pickup for smooth and comfortable travel experiences."
      },
      {
        WhyChooseheading: "Affordable Innova Crysta Rental Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Innova Crysta on rent in Pune with transparent pricing and no hidden charges. Customers receive complete fare details before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Innova Crysta Availability",
        WhyChoosedescription: "Our Innova Crysta rental service in Pune operates 24 hours a day for airport transfers, family tours, corporate travel, weddings, pilgrimage trips, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Luxury & Comfortable AC Innova Crysta",
        WhyChoosedescription: "All Innova Crysta vehicles provided by Shivai Travels are fully air-conditioned, sanitized, spacious, and regularly maintained to provide premium travel comfort for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Booking Options",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Innova Crysta booking, round-trip travel, local sightseeing, airport transfers, and customized outstation travel packages."
      },
      {
        WhyChooseheading: "Premium Vehicle for Family & Corporate Travel",
        WhyChoosedescription: "The Innova Crysta is ideal for families, corporate travelers, tourists, wedding guests, and VIP travel with spacious seating, luggage capacity, and luxury interiors."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Long-Distance Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune city routes, highways, hill stations, Konkan roads, and interstate destinations, ensuring safe driving and smooth travel for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Innova Crysta rental service in Pune?", answer: "Innova Crysta rental service in Pune provides luxury taxi transportation for family trips, corporate travel, airport transfers, weddings, and outstation journeys." },
    { question: "Is Innova Crysta on rent in Pune available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Innova Crysta rental service in Pune." },
    { question: "How many passengers can travel in an Innova Crysta?", answer: "Innova Crysta vehicles are suitable for 6 to 7 passengers with comfortable seating and luggage space." },
    { question: "Can I book Innova Crysta for outstation travel?", answer: "Yes, customers can book Innova Crysta vehicles for local sightseeing, outstation tours, airport transfers, and corporate travel." },
    { question: "Do you provide one-way and round-trip Innova Crysta service?", answer: "Yes, Shivai Travels provides both one-way and round-trip Innova Crysta booking services." },
    { question: "Are all Innova Crysta vehicles air-conditioned?", answer: "Yes, all Innova Crysta vehicles are fully air-conditioned and maintained for comfortable luxury travel." },
    { question: "Can I book Innova Crysta on rent in Pune online?", answer: "Yes, customers can easily book Innova Crysta rental service online or through phone booking." },
    { question: "Do you provide Innova Crysta for weddings and corporate events?", answer: "Yes, Shivai Travels provides Innova Crysta vehicles for weddings, corporate outings, VIP travel, and family group transportation." },
    { question: "Are Innova Crysta rental fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Innova Crysta rental in Pune?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajay Deshmukh",
    feedback:
      "Had a premium Innova Crysta on rent in Pune with a very comfortable ride, spacious seating, and a professional driver ensuring a smooth long-distance journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "The Innova Crysta rental service in Pune was excellent with a clean luxury vehicle, on-time pickup, and a stress-free travel experience for our family trip.",
    rating: 5
  }
];




  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta on Rent in Pune",
  "image": "https://shivaitravels.com/assets/images/innova-crysta-pune.jpg",
  "description": "Book Innova Crysta on rent in Pune for comfortable family trips, airport transfers, weddings, and outstation travel. Shivai Travels offers premium SUV cab service with experienced drivers, spacious seating, and reliable long-distance travel options.",
  "brand": {
    "@type": "Brand",
    "name": "Shivaitravels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹18/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/innova-crysta-on-rent-in-pune"
  }
};







  return (
    <div>


<Helmet>
  <title>Innova Crysta on Rent in Pune | SUV Cab Booking | +91 9689815477</title>

  <meta
    name="description"
    content="Book Innova Crysta on rent in Pune for family trips, weddings, airport transfers, and outstation travel. Premium SUV cab service with comfort, safety, and experienced drivers."
  />

  <meta
    name="keywords"
    content="innova crysta rental pune, pune innova crysta cab, innova crysta on hire pune, innova crysta taxi pune, pune innova crysta booking, cheap innova crysta pune, outstation innova crysta pune, innova crysta for family trip pune, pune airport innova crysta cab, innova crysta wedding rental pune, innova crysta one way pune, innova crysta round trip pune, best innova crysta service pune, suv innova crysta hire pune, premium innova crysta pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/82.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystaonrentinpune;